import { useUser } from "../contexts/user-context";
import { getHightouchRegionConfig, HightouchRegionConfig } from "./regions";

export function useRegionConfig(): HightouchRegionConfig {
  const { region } = useUser();
  return getHightouchRegionConfig(region);
}
